import { NgModule, ErrorHandler as NgErrorHandler } from "@angular/core";
import { ErrorHandler } from "./handler";
import { ErrorHandlerService } from "./service";

@NgModule({
  providers: [
    {
      provide: NgErrorHandler,
      useClass: ErrorHandler
    },
    ErrorHandlerService
  ]
})
export class ErrorHandlerModule {}
